import type { UserCore } from '../../interfaces/User.interface';

export interface State {
    currentUser: UserCore | null;
    isPending: boolean;
    isCurrentUserLoaded: boolean;
    rights: string[];
    areRightsLoaded: boolean;
}

export const initialState: State = {
    currentUser: null,
    isPending: false,
    isCurrentUserLoaded: false,
    rights: [],
    areRightsLoaded: false
};
